import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 165 136",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_1291_452)\"><rect x=\"-3\" y=\"-2\" width=\"43\" height=\"141\" fill=\"#AB7EFF\"></rect><rect x=\"40\" y=\"-2\" width=\"42\" height=\"141\" fill=\"#7C52FF\"></rect><rect x=\"82\" y=\"-2\" width=\"43\" height=\"141\" fill=\"#3A1D95\"></rect><rect x=\"125\" y=\"-2\" width=\"42\" height=\"141\" fill=\"#10022C\"></rect></g><defs><clipPath id=\"clip0_1291_452\"><rect width=\"165\" height=\"136\" rx=\"8\" fill=\"white\"></rect></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }